<div #listDom class="relative w-full h-full flex overflow-hidden">
  <div
    class="relative p-1 lg:p-2 h-full flex-none flex flex-row flex-nowrap justify-start items-start gap-1 lg:gap-2"
  >
    @for (category of project?.partCategories; track category.uuid) {
      <button
        class="relative h-full py-1 px-4 lg:px-8 flex-none flex flex-col justify-between items-center transition-all transform duration-150 ease-in-out rounded-lg"
        [ngClass]="{
          ' text-black dark:text-white bg-white dark:bg-[#000000] ring-2 ring-[#7F8084] ':
            selectedCategory() == category.title,
          'text-[#7F8084] bg-[#E3E4E1] dark:bg-[#3A3941] ring-none':
            selectedCategory() != category.title,
        }"
        (click)="onClickBottomButtonHandler(category.title)"
      >
        <div class="relative h-3/5 z-10 flex justify-end items-center select-none">
          @if (category.icon) {
            <div class="relative h-full select-none">
              <img
                [src]="category.icon"
                [alt]="category.title"
                class="object-cover h-full select-none"
                [ngClass]="{
                  ' text-black dark:text-white': selectedCategory() == category.title,
                  'text-[#7F8084] ': selectedCategory() != category.title,
                }"
                draggable="false"
              />
            </div>
          } @else {
            <!-- <mat-icon>star</mat-icon> -->
          }
        </div>
        <div
          class="text-xs lg:text-sm xl:text-base font-semibold text-black/70 dark:text-white/70 px-1 lg:px-2 z-10 select-none"
          [innerText]="category.title"
        ></div>
      </button>
    }
  </div>
</div>
